const state = {
	cartItemList: [
	]
}

const mutations = {
	// 'UPDATE_CART'(state, { item, quantity, isAdd }) {
	'UPDATE_CART'(state, { item, quantity }) {
		const recordIndex = state.cartItemList.findIndex(element => element.id == item.id);
		if (recordIndex >= 0) {
			// console.log(isAdd)
			//Replace existing cart item with new one
			// if(isAdd){}

			state.cartItemList.splice(recordIndex, 1, {
				...item,
				quantity
			})
			
			// if (isAdd) {
			// 	record.quantity += quantity;
			// } else {
			// 	record.quantity = quantity;
			// }
		} else {
			state.cartItemList.push({
				...item,
				quantity
			});
		}
	},
	'SET_CART'(state, productList) {
		if (productList) {
			state.cartItemList = productList;
		}
	},
	'CLEAR_CART'(state) {
		state.cartItemList = [];
	},
	'REMOVE_CART_ITEM'(state, { item }) {
		const recordIndex = state.cartItemList.findIndex(element => element.id == item.id);
		state.cartItemList.splice(recordIndex, 1);
	}
}

const actions = {
	clearCart: ({ commit }) => {
		commit('CLEAR_CART');
	},
	updateCart: ({ commit }, { item, quantity, isAdd }) => {
		// console.log('updating quantity cart item')
		// console.log(item)
		commit('UPDATE_CART', { item, quantity, isAdd });
		if (isAdd) {
			let message_obj = {
				message: `Add ${item.name} to cart successfully`,
				messageClass: "success",
				autoClose: true
			}
			commit('ADD_MESSAGE', message_obj);
		}
	},
	removeItemInCart: ({ commit }, { item }) => {
		// console.log('removing cart item')
		// console.log(item)
		commit('REMOVE_CART_ITEM', { item });
	}
}

const getters = {
	cartItemList: (state) => {
		return state.cartItemList;
	},
	cartValue: (state) => {
		let res = 0;
		state.cartItemList.map(item => {
			if(item.subject == 'Camp'){
				res += item.pricePerWeek * item.weeks.length;
			}
			else{
				res += item.pricePerCourse * item.quantity;
			}
		});
		return res;
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}
